import * as angular from 'angular';
import * as _ from 'lodash';
import ResourceService from './resource.service';
import RoleResource from '../models/role-resource';

export default class RoleService extends ResourceService<RoleResource> {
  constructor(BaseResource) {
    super(BaseResource, RoleResource);
  }
}

angular.module('ciApp.services').service('RoleService', ['BackendService', RoleService]);



// WEBPACK FOOTER //
// ./common/services/role.service.ts